/** Значения совпадают с токеном --vp-bg для светлой/тёмной темы. */
const CHROME_HEX = {
    dark: "#0e0e10",
    light: "#fff5f4",
};
/**
 * Синхронизирует meta theme-color и фон documentElement с фоном текущей темы,
 * чтобы при модалках/оверлеях браузер не подхватывал посторонний оттенок.
 */
export function syncMobileBrowserChromeColor(scheme) {
    if (typeof document === "undefined")
        return;
    const c = CHROME_HEX[scheme];
    document.documentElement.style.setProperty("background-color", c);
    const ensureMeta = (name) => {
        let el = document.querySelector(`meta[name="${name}"]`);
        if (!el) {
            el = document.createElement("meta");
            el.setAttribute("name", name);
            document.head.appendChild(el);
        }
        if (el.getAttribute("content")?.toLowerCase() !== c.toLowerCase()) {
            el.setAttribute("content", c);
        }
    };
    ensureMeta("theme-color");
    ensureMeta("msapplication-TileColor");
}
/** Подписка на изменения document.head (если что-то перезапишет theme-color). */
export function observePinnedMobileBrowserChrome(scheme) {
    syncMobileBrowserChromeColor(scheme);
    const obs = new MutationObserver(() => {
        syncMobileBrowserChromeColor(scheme);
    });
    obs.observe(document.head, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["content", "name"],
    });
    return () => {
        obs.disconnect();
    };
}
